var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{style:(_vm.inputStyle),attrs:{"type":"button","name":"","value":_vm.value,"disabled":_vm.disable}})}
var staticRenderFns = []

export { render, staticRenderFns }